export default "__VITE_ASSET__9VrPDEX1__"